import { Button, Col, Pagination, Row, Space, Table } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { BiRefresh } from 'react-icons/bi';
import styled from 'styled-components';
import { ITable } from '../../model/PaginatedTableModel';
import { NAV_HEADER_HEIGHT, TABLE_HEADER_HEIGHT } from '../../utils/app-common';
import { PaginationProps } from 'antd/es/pagination';
import { trackPromise } from 'react-promise-tracker';

const TableDiv = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const PaginationDiv = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const showTotal: PaginationProps['showTotal'] = total => `Total ${total} items`;

export default function PaginatedTableComponent({
    isLoading,
    data,
    columns,
    rowKey = 'id',
    current,
    pageSize = 10,
    total,
    onPaginationChange,
    isRefresh = false,
    onRefreshHandle,
    expandable,
    tableSize = 'middle',
    // Need to check below
    title,
    onShowSizeChange,
    onRowSelect,
    scroll = { y: 510, x: 1500 },
    rowSelection,
    showRowSelection = false,
    pageNumber = 0,
    children,
    hideOnSinglePage = false,
    components = undefined,
    rowClassName,
    indentSize = 0,
    paginationDisabled = false,
    leftContent,
    ...props
}: ITable) {

    const [tableHeight, setTableHeight] = useState(750);
    // ref is the Table ref.
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const node = ref?.current;
        const { top } = node?.getBoundingClientRect()! || {};
        setTableHeight((window.innerHeight - top - (NAV_HEADER_HEIGHT + TABLE_HEADER_HEIGHT)) || 510);
    }, [ref]);



    return (
        <TableDiv>
            <Row justify='space-between' gutter={6} align={'middle'}>
                <Col style={{ paddingLeft: 8 }}>
                    {leftContent}
                </Col>
                <Col>
                    <Space align='center' direction='horizontal' size={2}>
                        {children}
                        {isRefresh ?
                            <Button loading={isLoading} type='default' onClick={onRefreshHandle}
                                icon={<BiRefresh size={18}></BiRefresh>} />
                            : null}
                    </Space>
                </Col>
            </Row>
            <Table
                {...props}
                loading={isLoading}
                columns={columns}
                dataSource={data}
                rowKey={row => row[rowKey]}
                pagination={false}
                expandable={expandable}
                size={tableSize}
                // Need to check below
                components={components}
                rowClassName={rowClassName}
                key={rowKey}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: () => onRowSelect?.(record, rowIndex), // click row
                    };
                }}
                indentSize={indentSize}
                rowSelection={showRowSelection ? {
                    type: 'checkbox',
                    ...rowSelection,
                } : undefined}
                scroll={{ ...scroll, y: scroll?.y ? scroll?.y : tableHeight }}
            />
            {!paginationDisabled ? <PaginationDiv>
                <Pagination
                    current={current}
                    pageSize={pageSize}
                    total={total}
                    onChange={onPaginationChange}
                    showTotal={showTotal}
                    showSizeChanger
                />
            </PaginationDiv> : null}
        </TableDiv>
    );
}